<template>
  <div class="container">
    <br>
    <el-row type="flex" justify="center">
      <el-col :xs="20" :sm="18" :md="14" :lg="8">

        <el-form :label-position="'right'" :model="resetForm" :rules="resetRules" ref="resetForm" label-width="80px"  >
          <el-row :gutter='0' style="text-align: center">
            <el-col><h2>重置密码</h2></el-col>
          </el-row>
          <el-form-item label="邮件地址" prop="email">
            <el-input v-model="resetForm.email" placeholder="Email" readonly></el-input>
          </el-form-item>
         
          <el-form-item label="新密码" prop="new_password">
            <el-input v-model="resetForm.new_password" type="password" size='40' placeholder="Password"></el-input>
          </el-form-item>
          
          <el-form-item label="密码确认" prop="confirm_password">
            <el-input type="password" v-model="resetForm.confirm_password"  size='40' placeholder="Password"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="submitForm('resetForm')">确认重置</el-button>  
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script type='text/javascript'>
import $ from 'jquery'
export default {
  name: 'resetPassword',
  data () {
    let eqValidatePass = (rule, value, callback) => {
      if (value !== this.resetForm.new_password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      resetForm: {
        email: this.$route.params.email,
        token: this.$route.params.token,
        new_password: '',
        confirm_password: ''
      },
      resetRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', required: true, message: '请输入可用的邮件地址', trigger: 'blur' },
          { max: 50, message: '您的用户名至多包含50个字符', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '您的密码需要至少包含6个字符', trigger: 'blur' },
          { max: 40, message: '您的密码至多包含40个字符', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '您的密码需要至少包含6个字符', trigger: 'blur' },
          { max: 40, message: '您的密码至多包含40个字符', trigger: 'blur' },
          { validator: eqValidatePass, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    const vm = this
    // 先判断令牌是否合法，如果不合法，则直接跳转
    $.ajax({
      type: 'GET',
      url: '/v1/user/login/resetPasswordLinkAvalibale',
      dataType: 'json',
      async: true,
      data: {
        email: vm.resetForm.email,
        token: vm.resetForm.token
      },
      success: function (data) {
        if (data.code === 200) {
          // 不做处理
        } else if (data.code === 503) {
          vm.$router.push('/user/forgotpassword')
          vm.$message.error('重置密码链接错误，或者已经失效！')
        } else if (data.code === 504) {
          vm.$router.push('/user/forgotpassword')
          vm.$message.error('重置密码链接已经过期，请重新进行密码找回操作')
        } else {
          vm.$router.push('/user/forgotpassword')
          vm.$message.error('重置密码链接错误，或者已经失效！')
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        if (textStatus === 'timeout') {
          vm.$message.error('响应超时，请稍后重试')
        } else if (errorThrown === 'Unauthorized') {
          vm.$message.error('未授权')
        } else {
          vm.$message.error('系统异常，请稍后重试')
        }
      }
    })
  },
  methods: {
    submitForm (formName) {
      const vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $.ajax({
            type: 'PATCH',
            url: '/v1/user/login/resetPassword',
            dataType: 'json',
            async: true,
            data: {
              email: vm.resetForm.email,
              token: vm.resetForm.token,
              newPassword: vm.resetForm.new_password
            },
            success: function (data) {
              if (data.code === 200) {
                // 重置密码密码成功
                vm.$router.push('/user/login')
                vm.$message.success('重置密码成功，请直接登录')
              } else if (data.code === 503) {
                vm.$router.push('/user/forgotpassword')
                vm.$message.error('重置密码链接有误，请确认')
              } else if (data.code === 504) {
                vm.$router.push('/user/forgotpassword')
                vm.$message.error('重置密码链接已经过期，请重新进行密码找回操作')
              } else {
                vm.$message.error('系统异常，请稍后重试')
              }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              if (textStatus === 'timeout') {
                vm.$message.error('响应超时，请稍后重试')
              } else if (errorThrown === 'Unauthorized') {
                vm.$message.error('未授权')
              } else {
                vm.$message.error('系统异常，请稍后重试')
              }
            }
          })
        } else {
          return false
        }
      })
    }
  }

    // 表格验证
    // $('#resetPassword').validate({
    //   onkeyup: false,
    //   rules: {
    //     email: {
    //       required: true,
    //       email: true,
    //       maxlength: 50
    //     },
    //     password: {
    //       required: true,
    //       minlength: 6,
    //       maxlength: 40
    //     },
    //     confirm_password: {
    //       required: true,
    //       minlength: 6,
    //       maxlength: 40,
    //       equalTo: '#password'
    //     }
    //   },
    //   messages: {
    //     email: {
    //       required: '请输入注册邮箱',
    //       email: '请输入可用的邮件地址',
    //       maxlength: '您的用户名至多包含50个字符'
    //     },
    //     password: {
    //       required: '请输入密码',
    //       minlength: '您的密码需要至少包含6个字符',
    //       maxlength: '您的密码至多包含40个字符'
    //     },
    //     confirm_password: {
    //       required: '请输入密码',
    //       minlength: '您的密码需要至少包含6个字符',
    //       maxlength: '您的密码至多包含40个字符',
    //       equalTo: '两次输入的密码不一致'
    //     }
    //   },
    //   errorElement: 'em',
    //   errorPlacement: function (error, element) {
    //     // Add the `help-block` class to the error element
    //     error.addClass('help-block')
    //     // Add `has-feedback` class to the parent div.form-group
    //     // in order to add icons to inputs
    //     element.parents('.errorPlace').addClass('has-feedback')

    //     if (element.prop('type') === 'checkbox') {
    //       error.insertAfter(element.parent('label'))
    //     } else {
    //       error.insertAfter(element)
    //     }
    //     // Add the span element, if doesn't exists, and apply the icon classes to it.
    //     if (!element.next('span')[0]) {
    //       $('<span class="glyphicon glyphicon-remove form-control-feedback"></span>').insertAfter(element)
    //     }
    //   },
    //   success: function (label, element) {
    //     // Add the span element, if doesn't exists, and apply the icon classes to it.
    //     if (!$(element).next('span')[0]) {
    //       $('<span class="glyphicon glyphicon-ok form-control-feedback"></span>').insertAfter($(element))
    //     }
    //   },
    //   highlight: function (element, errorClass, validClass) {
    //     $(element).parents('.errorPlace').addClass('has-error').removeClass('has-success')
    //     $(element).next('span').addClass('glyphicon-remove').removeClass('glyphicon-ok')
    //   },
    //   unhighlight: function (element, errorClass, validClass) {
    //     $(element).parents('.errorPlace').addClass('has-success').removeClass('has-error')
    //     $(element).next('span').addClass('glyphicon-ok').removeClass('glyphicon-remove')
    //   },
    //   submitHandler: function (form) {
    //     $.ajax({
    //       type: 'PATCH',
    //       url: '/v1/user/login/resetPassword',
    //       dataType: 'json',
    //       async: true,
    //       data: {
    //         email: vm.email,
    //         token: vm.token,
    //         newPassword: vm.newPassword
    //       },
    //       success: function (data, textStatus, jqXHR) {
    //         if (data.code === 200) {
    //           // 重置密码密码成功
    //           vm.$router.push('/user/login')
    //           vm.$message.success('重置密码成功，请直接登录')
    //         } else if (data.code === 503) {
    //           vm.$router.push('/user/forgotpassword')
    //           vm.$message.error('重置密码链接有误，请确认')
    //         } else if (data.code === 504) {
    //           vm.$router.push('/user/forgotpassword')
    //           vm.$message.error('重置密码链接已经过期，请重新进行密码找回操作')
    //         } else {
    //           vm.$message.error('系统异常，请稍后重试')
    //         }
    //       },
    //       error: function (XMLHttpRequest, textStatus, errorThrown) {
    //         if (textStatus === 'timeout') {
    //           vm.$message.error('响应超时，请稍后重试')
    //         } else if (errorThrown === 'Unauthorized') {
    //           vm.$message.error('未授权')
    //         } else {
    //           vm.$message.error('系统异常，请稍后重试')
    //         }
    //       }
    //     })
    //   }
    // })
}
</script>
